import React, { ReactElement } from 'react';
import { AppLinksProps } from '../types';

export const AppLinks = ({ config, history }: AppLinksProps): (ReactElement | null)[] => {
  const { pathname, search } = history?.location;
  const { appleStoreId, shortName, androidId } = config;

  const deepLink = `${config.appUrlScheme}${pathname}${search}`;
  const url = `${config.domainUrl}${pathname}${search}`;

  const appLinks = [
    { property: 'al:ios:url', content: encodeURI(deepLink) },
    { property: 'al:ios:app_store_id', content: encodeURI(appleStoreId) },
    { property: 'al:ios:app_name', content: encodeURI(shortName) },
    { property: 'al:android:url', content: encodeURI(deepLink) },
    { property: 'al:android:app_name', content: encodeURI(shortName) },
    { property: 'al:android:package', content: encodeURI(androidId) },
    { property: 'al:web:url', content: encodeURI(url) },
  ];

  return appLinks.map(appLink => <meta key={appLink.property} {...appLink} />);
};
